import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../../commons/app-commons.module';

import { KYMW5002ImageInfoDetailComponent } from './kymw5002-image-info-detail.component';

import { KYMW5002ImageInfoDetailBoxModule } from '../kymw5002-image-info-detail-box/kymw5002-image-info-detail-box.module';

/**
 * EC使用画像指示画面 モジュール設定クラス
 *
 * @export KYMW5002ImageInfoDetailModule
 * @class KYMW5002ImageInfoDetailModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    KYMW5002ImageInfoDetailBoxModule,
  ],
  declarations: [
    KYMW5002ImageInfoDetailComponent,
  ],
  providers: [
  ],
  exports: [
    KYMW5002ImageInfoDetailComponent
  ]
})
export class KYMW5002ImageInfoDetailModule {

}
